'use es6';

import { List } from 'immutable';
export const isDataEmpty = data => {
  if (!data) return true;
  if (List.isList(data)) return data.size === 0;
  return false;
};